/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Pagination } from 'antd-v5';
import ViewAll from '../../../../../../components/Routes/ClientsV2/components/ViewAll';
import QuickViewSkeletonCard from '../../components/QuickViewSkeletonCard';
import AutoMessageCard from '../AutoMessageCard';

const ViewAllAutoMessages = ({ setViewAllType, client, associate_name, isFetching, refetch, auth }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  return (
    <ViewAll title="All Auto Messages" setViewAllType={() => setViewAllType(null)}>
      <div className="flex-col w-100-P gap-16">
        {isFetching ? (
          Array(5)
            .fill(null)
            .map((_, index) => <QuickViewSkeletonCard key={index} />)
        ) : client?.autoMessages?.length > 0 ? (
          <>
            {client?.autoMessages?.slice((page - 1) * pageSize, page * pageSize)?.map(msg => (
              <AutoMessageCard
                key={msg.id}
                {...msg}
                client_name={
                  msg?.relationship_type_id ? msg?.relation_name || '' : client?.preferred_name || client?.name
                }
                associate_name={associate_name}
                review_link=""
                relation={msg?.relationship_type_id ? client?.name : ''}
                client={client}
                auth={auth}
                onDelete={refetch}
              />
            ))}
            <div className="flex-row justify-end">
              <Pagination
                pageSizeOptions={[5, 10, 20]}
                current={page}
                pageSize={pageSize}
                total={client?.autoMessages?.length || 0}
                onChange={p => setPage(p)}
                showSizeChanger
                onShowSizeChange={(current, size) => setPageSize(size)}
              />
            </div>
          </>
        ) : (
          <div>No Auto Messages found</div>
        )}
      </div>
    </ViewAll>
  );
};

function mapStateToProps(state) {
  const { auth, client } = state;

  return {
    userId: auth.userId,
    clientId: client.id,
    merchantId: auth.merchantId,
    auth,
  };
}
export default connect(mapStateToProps, {})(ViewAllAutoMessages);
